/**
 * The standard names of the patient fields a connector writes (ADR-282). A
 * connector that reports a refused field (`ConnectorError.fields`) names it with
 * these, never with its EHR's own name (athena's `MOBILEPHONE` is `phone`), so the
 * API can pass the list on untouched and the UI can point at its own input.
 *
 * Connector request bodies, their EHR field maps and the UI's form mapping are all
 * typed against {@link EhrPatientField}: renaming one here is a compile error at
 * every place that has to follow.
 */
export const EHR_PATIENT_FIELD = {
  firstName: 'firstName',
  lastName: 'lastName',
  dateOfBirth: 'dateOfBirth',
  gender: 'gender',
  phone: 'phone',
  email: 'email',
  address1: 'address1',
  address2: 'address2',
  city: 'city',
  state: 'state',
  zip: 'zip',
  departmentId: 'departmentId',
} as const;

export type EhrPatientField = (typeof EHR_PATIENT_FIELD)[keyof typeof EHR_PATIENT_FIELD];
